module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_25000_50000.cd23e1f0.png";